import useSWR from "swr";
import { AssetsRequestOld, AssetsResponse, CoverAssetItem } from "@/interfaces/nftTypes";
import * as http from "@/utils/request";
import { RFResponse } from "@/interfaces/common";
const baseUrl = process.env.NEXT_PUBLIC_BASE_API;

/**
 * 获取NFT资产列表
 */
// export const useAssets = (payload: AssetsRequestOld) => {
//   const url = "http://10.131.18.44:30700/mock/3" + "/nft/asset/filter";
//   return useSWR<AssetsResponse>([url, payload], (url, payload) =>
//     http.post(url, payload)
//   );
// };

export const useFilterCovers = ({ type, value }: { type: string; value: string }) => {
	const url = `${baseUrl}/watchlist/api/nft/covers?${type}=${value}`;
	const { data, error, mutate, isValidating } = useSWR<CoverAssetItem[] | null>(url, async (url: string) => {
		const { code, data } = await http.get<RFResponse<CoverAssetItem[]>>(url);
		if (code == 200) {
			return data;
		}
		return [];
	});

	return {
		assets: data,
		isLoading: isValidating,
		isError: error,
		mutate,
	};
};
